import { playVideo, initElements } from '../define/shared';

export default function initMediaBlocks() {
    initElements('.wab.wab-mediab', initMediablock);
}

/**
 * @param {HTMLElement} root
 */
export function initMediablock(root) {

    initElements({
        root,
        selector: '.b-video',
    }, videoEl => {
        const btn = videoEl.querySelector('.b-video-playBtn');
        const container = videoEl.querySelector('.b-video-inner');
        btn.addEventListener('click', event => {
            videoEl.classList.add('is--initialized');
            playVideo(container, {
                videoId: videoEl.dataset.id,
                provider: videoEl.dataset.provider,
                background: false,
            });
        }, { once: true });
    });
}
